import { GROUP_ENDPOINT } from "../config/constants"
import { authorizeHeader } from "../utils/auth-header"


export const getCheckGroupAPICall = async ({ userGroupName }) => {
    try {
      const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
      const response = await window.fetch(GROUP_ENDPOINT + '/' + encodeURIComponent(userGroupName), authorizeHeader(config))
      const responseOk = await response.status === 200
      const responseJSON = await response.json()
      return { responseOk, responseJSON }
    } catch (e) {
      console.error('ERROR: ', e)
      return e
    }
  }

  export const postCreateGroupAPICall = async ({ userGroupName }) => {
    try {
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ name: userGroupName })
      }
      const response = await window.fetch(GROUP_ENDPOINT, authorizeHeader(config))
      const responseOk = await response.status === 200
      const responseJSON = await response.json()
      return { responseOk, responseJSON }
    } catch (e) {
      console.error('ERROR: ', e)
      return e
    }
  }